<template>
    <div class="h-full">
        <Head :title="__(title)" />
        <board-view-menu :project="project" view="overview" />
        <div class="flex flex-col task__dashboard px-4 py-4 gap-4 h-[calc(100%-52px)] overflow-hidden overflow-y-auto">
            <div class="flex gap-5 flex-col lg:flex-row w-full">
                <div class="w-full bg-white rounded-lg shadow-lg p-10">
                    <span class="h2 font-bold mb-8">Project Details</span>
                    <div class="flex flex-wrap -mb-8 mt-8 -mr-6">
                        <div class="pb-8 pr-6 w-full lg:w-1/2">
                            <div class="w-full bg-white rounded-lg shadow-lg p-10">
                                <!-- ApexChart for task status distribution -->
                                <apexchart
                                    type="donut"
                                    :options="chartOptions"
                                    :series="chartData"
                                    height="400"
                                ></apexchart>
                            </div>
                        </div>

                        <div class="flex flex-wrap pb-8 pr-6 w-full lg:w-1/2">
                            <div class="w-full lg:w-1/1">
                                <div class="info-row">
                                    <div class="label">Name: &nbsp;</div>
                                    <div class="value">{{ project.title }}</div>
                                </div>
                            </div>
                            <div class="w-full lg:w-1/1">
                                <div class="info-row">
                                    <div class="label">Workspace name: &nbsp;</div>
                                    <div class="value">{{ project.workspace.name }}</div>
                                </div>
                            </div>

                            <div class="w-full lg:w-1/2">
                                <div class="info-row">
                                    <div class="label">Goal: &nbsp;</div>
                                    <div class="value"></div>
                                </div>
                            </div>

                            <div class="w-full lg:w-1/2">
                                <div class="info-row">
                                    <div class="label">Goal Details: &nbsp;</div>
                                    <div class="value"></div>
                                </div>
                            </div>

                            <div class="w-full lg:w-1/1">
                                <div class="info-row">
                                    <div class="label">Project details: &nbsp;</div>
                                    <div class="value">{{ project.description }}</div>
                                </div>
                            </div>

                            <div class="w-full lg:w-1/1">
                                <div class="info-row">
                                    <div class="label">Created at: &nbsp;</div>
                                    <div class="value">{{ project.created_at }}</div>
                                </div>
                            </div>

                            <div class="w-full">
                                <div class="info-row">
                                    <div class="label">Team member's: &nbsp;</div>
                                </div>
                                <div class="w-full">
                                    <table class="tbl_qualification">
                                        <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Email</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="member in project.workspace.member_list" :key="member.id">
                                            <td>{{ member.user.name }}</td>
                                            <td>{{ member.user.email }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <hr/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import Icon from '@/Shared/Icon'
import BoardViewMenu from '@/Shared/BoardViewMenu'
import FloatingNewTaskBtn from '@/Shared/FloatingNewTaskBtn'
import ApexChart from 'vue3-apexcharts' // Import ApexChart component

export default {
    components: {
        FloatingNewTaskBtn,
        Head,
        Icon,
        Link,
        BoardViewMenu,
        ApexChart, // Register ApexChart
    },
    layout: Layout,
    props: {
        title: String,
        auth: Object,
        project: Object,
        per_list: Object,
        per_assignee: Object,
        per_label: Object,
        tasks:Array,
        board_lists:Array,
        due_data: {
            required: true,
        },
    },
    data() {
        console.log(this.board_lists)
        return {
            taskStatus:{},
            chartData: [],
            chartLabels: [],
        }
    },
    methods:{
        calculateTaskStats() {
            let totalTasks = 0;
            let tasksByTitle = {}; // Store final tasks with percentages
            let tasksTitle = {}; // Store tasks with details by title

            // Loop through each list and calculate task counts
            this.board_lists.forEach(list => {
                const tasks = list.tasks;
                const title = list.title;
                const totalTasksInList = tasks.length;
                const tasksInToDo = tasks.filter(task => task.is_done === 0).length;

                totalTasks += totalTasksInList;

                // Store data for each status list (e.g., "Stories", "In Progress")
                tasksTitle[title] = {
                    total: totalTasksInList,
                    inToDo: tasksInToDo,
                    title: title,
                    percentageInToDo: totalTasksInList ? (tasksInToDo / totalTasksInList) * 100 : 0
                };
            });

            // Calculate the percentage of total tasks for each list (status group)
            Object.values(tasksTitle).forEach(list => {

                console.log(list)
                tasksByTitle[list.title] = {
                    percentage: (list.total / totalTasks) * 100 // Percentage of total tasks in that status
                };
            });
            console.log("here")
            console.log(tasksByTitle); // Output the task breakdown by status group

            // Update chart data and labels
            this.chartData = Object.values(tasksByTitle).map(stat => stat.percentage); // Get the percentage values
            this.chartLabels = Object.keys(tasksByTitle); // Get the titles (status names)
        }

    },
    computed: {
        // Compute the chart data
        chartOptions() {
            return {
                chart: {
                    type: 'donut', // Type of chart (donut for round chart)
                },
                labels: this.chartLabels, // Labels for the statuses
                title: {
                    text: 'Task Distribution by Status',
                    align: 'center'
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }],
                colors: ['#4CAF50', '#FFC107', '#2196F3','#FF6384','#4BC0C0'], // Colors for each section
                legend: {
                    position: 'bottom'
                }
            };
        }
    },
    created() {
        this.calculateTaskStats();
    },
}
</script>

<style scoped>
/* Add any necessary custom styles here */
.tbl_qualification th, .tbl_qualification td {
    padding: 8px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}
</style>
